<script>
    import {_} from 'svelte-i18n';
    import {Icon} from 'svelma';
</script>

<div class="columns p-2 mt-4">
    <div class="column"></div>
    <div class="column is-narrow has-text-centered-mobile">2021 © PTE MIK - {$_('footer.rightsMessage')}</div>
    <div class="column"></div>
</div>
